import React, { useState, useEffect } from 'react';
import { isChrome, isBrowser } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

const NotOptimizedBrowserBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isBrowser && !isChrome) {
      setVisible(true);
    }
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed w-full p-5 font-medium text-center text-blue bg-blue-light text-md">
      {t('header__banner_not_optimized_text')}
      <a
        className="ml-2 uppercase text-blue hover:text-primary-dark hover:underline"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.google.com/chrome/"
      >
        {t('header__banner_not_optimized_cta')}
      </a>
      <button
        style={{ top: '8px', right: '8px' }}
        className="absolute flex items-center justify-center w-2 h-2 text-blue"
        onClick={() => setVisible(false)}
      >
        x
      </button>
    </div>
  );
};

export default NotOptimizedBrowserBanner;
